import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';

export class GetDriversDashboardCommand extends IRequestCommand<
  IGetDriversDashboardResponse,
  ErrorDetails,
  IGetDriversDashboardParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/dashboard?page=0&size=999999&column=code&sort=ASC&value=&states=&driverId=&vehicleIdSwitch=false';

  public override setParameters(parameters: IGetDriversDashboardParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierUserId}', parameters.carrierUserId);
  }
}

export interface IGetDriversDashboardParameters extends ICommandParameters {
  carrierUserId: string;
}

export interface DriverDashboardDTO {
  driverUserId: number;
  driverIdForCarrier: number;
  vehicleIdForCarrier: number;
  firstName: string;
  lastName: string;
  appDriverVersion: string;
  state: string;
  onSchedule: boolean;
  outOfService: boolean;
  noShowAdv: boolean;
  vehicles: number;
  vehicle: {
    domain: string;
    mark: string;
    model: string;
    transportTypeDescription: string;
  };
  currentBase: string;
  queueFifoPosition: number;
  latitude: number;
  longitude: number;
}

export interface IGetDriversDashboardResponse extends ICommandResponse {
  content: DriverDashboardDTO[];
  totalElements: number;
}
